import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from "react-router-dom";
import Header from '../header/Header';
import Sidebar from '../sidebar/Sidebar';
import Tool from '../sidebar/Tool';
import Footer from '../footer/Footer';
import { GetCategoryAction, AddCategorAction } from '../action/CategoryAction';
import { useDispatch, useSelector } from 'react-redux'

export default function AddProduct() {
  const [root, setRoot] = useState("")
  const [category, setCategory] = useState("")
  const [categoryId, setCategoryId] = useState("")
  const [gender, setGender] = useState("M")

  const dispatch = useDispatch();
  const [chooseFile, setChooseFile] = useState([]);
  const categoryValue = useSelector(state => state?.category)
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(GetCategoryAction())
  }, [])


  const createCategoryList = (categories, options = []) => {
    for (var category of categories) {
      options?.push({ value: category?._id, name: category?.name });
      if (category?.children?.length > 0) {
        // createCategoryList(category?.children,options)
        createCategoryList(category?.name)
      }
    }
    return options;
  }

  const addCategory = () => {
    const objData = {
      parentId: root,
      name: category,
      unqId: categoryId,
      genderBased: gender
    }
    dispatch(AddCategorAction(objData));
    navigate("/category")
  }


  return (
    <div className="sidebar-mini skin-green-light">
      <div className="wrapper">
        <Header />
        <Sidebar />

        {/* Content Wrapper. Contains page content */}
        <div className="content-wrapper">
          {/* Content Header (Page header) */}
          <section className="content-header">
            <h1>
              Add New Categories
              <small>it all starts here</small>
            </h1>
            <ol className="breadcrumb">
              <li>
                <a href="#">
                  <i className="fa fa-dashboard" /> Home
                </a>
              </li>
              <li>
                <a href="#">Product Manage</a>
              </li>
              <li className="active">All Product</li>
            </ol>
          </section>
          {/* Main content */}
          <section className="content">
            {/* Default box */}
            <div className="box">
              <div className="box-header with-border">
                <div className="box-tools pull-right">
                  <Link
                    to="/category"
                    type="button"
                    className="btn btn-success"
                    data-toggle="tooltip"
                    title="View"
                  >
                    <i className="fa fa-eye" />
                    {" View All Category "}
                  </Link>
                </div>
              </div>
              <div className="box-body">
                <div className="col-md-6">

                  <div className="box-body">
                    <div className="row">
                      <div className="col-xs-12">
                        <label>Root Category<span class="text-danger">*</span></label>
                        <select type="number" className="form-control" placeholder="Price" onChange={(e) => setRoot(e.target.value)}>
                          <option>Choose Categories</option>
                          {
                            createCategoryList(categoryValue?.categories?.categoryList).map(dt => (
                              <option key={dt?._id} value={dt?.value}>{dt.name}</option>
                            ))
                          }
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="box-body">
                    <div className="row">
                      <div className="col-xs-12">
                        <label>Gender <span class="text-danger">*</span></label>
                        <select onChange={(e) => setGender(e.target.value)} name='gender' className='form-control'>
                          <option value="M">Male</option>
                          <option value="F">Female</option>
                          <option value="K">Kids</option>
                          <option value="U">Home</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="box-body">
                    <div className="row">
                      <div className="col-xs-12">
                        <label>Category Name <span class="text-danger">*</span></label>
                        <input type="text" className="form-control" onChange={(e) => setCategory(e.target.value)} />
                      </div>
                    </div>
                  </div>

                  <div className="box-body">
                    <div className="row">
                      <div className="col-xs-12">
                        <label>Category Id <span class="text-danger">*</span></label>
                        <input type="text" name="categoryId" className="form-control" onChange={(e) => setCategoryId(e.target.value)} />
                      </div>
                    </div>
                  </div>

                  <div className="box-body">
                    <div className="row">
                      <div className="col-xs-12">
                        <button className="btn btn-primary" onClick={(e) => addCategory()}>Add Category</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="box-body">
                    <div className="row">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Footer />
        <Tool />
        <div className="control-sidebar-bg" />
      </div>
    </div>
  )
}